import type { TrainingSessionListView } from "@/api/training";
import { notifyWindowCapReached, windowStack, windowTaskbarTextLabel } from "@/app/windowStack";
import { sessionDisplayName } from "../trainingSessionFormat";

// sessionDatasets kind 엔트리의 params 계약. 콘텐츠는 세션 id 로 입력 목록을 받는다.
export type SessionDatasetsWindowParams = {
  sessionId: string;
};

// 세션의 입력 Dataset 을 전체 화면 창으로 연다(세션 목록 Dataset 칸의 `외 N건`). key 는 세션 id 다.
// 같은 세션의 창이 이미 있으면 그 창을 복원한다. 세션 상세 창과는 kind 가 달라 따로 열린다.
// cap(5)을 넘으면 열지 않고 toast 로 안내한다.
export function openSessionDatasetsWindow(session: TrainingSessionListView): void {
  const name = sessionDisplayName(session);
  const id = windowStack.open({
    kind: "sessionDatasets",
    key: session.id,
    title: name,
    // 작업표시줄에서 같은 세션의 상세 창과 구분한다.
    label: windowTaskbarTextLabel("Dataset:", name),
    params: { sessionId: session.id } satisfies SessionDatasetsWindowParams,
  });
  if (id === null) {
    notifyWindowCapReached();
  }
}
